import SEOMeta from '@/components/base/SEOMeta';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { siteInfo } from '@/mocks/site';
import { useState } from 'react';

const articleCategories = ['全部', '美妆护肤', '零食特产', '家居日用', '健康保健', '母婴用品', '购物指南'];

export default function ArticlesPage() {
  const [activeCategory, setActiveCategory] = useState('全部');

  const filteredArticles = activeCategory === '全部'
    ? [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    : articles.filter((a) => a.category === activeCategory)
        .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());

  const collectionPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `精选文章 - ${siteInfo.name}`,
    description: `日本精品购物指南、产品评测、使用心得分享 - ${siteInfo.name}`,
    url: `${siteInfo.url}/articles`,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
    },
  };

  return (
    <>
      <SEOMeta
        title={`精选文章 | 日本购物指南与好物推荐 - ${siteInfo.name}`}
        description={`浏览日本精品购物指南、产品评测、使用心得和品牌故事。${siteInfo.name}为您提供专业的日本购物建议。`}
        keywords={`日本购物指南,日本好物推荐,日本产品评测,${siteInfo.keywords}`}
        canonicalUrl={`${siteInfo.url}/articles`}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionPageSchema) }}
      />

      <div className="pt-20 pb-4 bg-background-100 min-h-screen">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '精选文章' },
          ]}
        />

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="mb-8">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精选文章
            </h1>
            <p className="text-sm text-foreground-500 mt-2">
              购物指南、使用心得、品牌故事——帮你选对每一件日本好物
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap items-center gap-2 mb-8">
            {articleCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  activeCategory === cat
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 border border-background-200/70 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {filteredArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {filteredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <i className="ri-article-line text-5xl text-foreground-300 mb-4 block"></i>
              <p className="text-foreground-500">该分类暂无文章</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}